import React from "react";
import { Star } from "lucide-react";
import { GOOGLE_REVIEW_URL } from "@/components/SocialLinks";

/**
 * "Leave us a Google review" CTA — used on booking + contact success screens.
 * Trust builder that gives visitors a subtle nudge without being pushy.
 */
const GoogleReviewCta = ({ variant = "inline" }) => {
  if (variant === "card") {
    return (
      <div
        className="mt-6 max-w-md mx-auto bg-white border border-black/8 rounded-md p-4 flex items-center gap-4 text-left"
        data-testid="google-review-cta-card"
      >
        <div className="shrink-0 flex items-center gap-0.5 text-[#FBBC05]">
          {Array.from({ length: 5 }).map((_, i) => (
            <Star key={i} className="h-4 w-4" fill="#FBBC05" strokeWidth={0} />
          ))}
        </div>
        <div className="flex-1">
          <div className="font-semibold text-[13px] text-ink leading-tight">Enjoyed working with us before?</div>
          <div className="text-[11px] text-muted-foreground">A quick Google review helps a small team like ours enormously.</div>
        </div>
        <a
          href={GOOGLE_REVIEW_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="google-review-cta-btn"
          className="shrink-0 whitespace-nowrap px-3 py-1.5 rounded-full bg-[#4285F4] hover:bg-[#3367d6] text-white text-[11px] font-semibold transition"
        >
          Leave a review
        </a>
      </div>
    );
  }
  return (
    <a
      href={GOOGLE_REVIEW_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="google-review-cta-btn"
      className="inline-flex items-center gap-2 text-[13px] font-semibold text-ink/70 hover:text-ink transition"
    >
      <span className="inline-flex items-center gap-0.5 text-[#FBBC05]">
        {Array.from({ length: 5 }).map((_, i) => (
          <Star key={i} className="h-3.5 w-3.5" fill="#FBBC05" strokeWidth={0} />
        ))}
      </span>
      Enjoyed working with us? Leave a Google review →
    </a>
  );
};

export default GoogleReviewCta;
